import { Td, Tr } from "@chakra-ui/react";
import { useState } from "react";
import { formatNumber } from "../formatting/formatNumber";
import { Product, ProductDraft, ProductTemplateField } from "../types";
import { ProductFieldCell } from "./ProductFieldCell";
import { displayTotalProductPrice } from "./productUtils";

export const ProductTableRow = ({
  product,
  templateFields,
}: {
  product: Product | ProductDraft;
  templateFields: ProductTemplateField[];
}) => {
  const [isExpanded, setIsExpanded] = useState(true);
  const toggle = () => setIsExpanded((expanded) => !expanded);

  return (
    <Tr key={product.id} maxWidth={"full"} overflow={"hidden"}>
      {templateFields
        .filter((f) => f.populatedBy === "Buyer")
        .map((field) => (
          <ProductFieldCell
            key={field.id}
            value={product.productFields.find((f) => f.name === field.name)?.value}
            isBoolean={field.type === "Boolean"}
            isExpanded={isExpanded}
            onToggle={toggle}
          />
        ))}
      <Td textAlign={"center"} verticalAlign={"top"}>
        {formatNumber(product.quantity.value)}
      </Td>
      <Td textAlign={"center"} verticalAlign={"top"}>
        {formatNumber(product.unitPrice?.value)}
      </Td>
      <Td textAlign={"center"} verticalAlign={"top"}>
        {displayTotalProductPrice(product)}
      </Td>
      {templateFields
        .filter((f) => f.populatedBy === "Supplier")
        .map((field) => (
          <ProductFieldCell
            key={field.id}
            value={product.productFields.find((f) => f.name === field.name)?.value}
            isBoolean={field.type === "Boolean"}
            isExpanded={isExpanded}
            onToggle={toggle}
          />
        ))}
    </Tr>
  );
};
